import { isEmpty, startCase } from "lodash";
import React, { useContext, useEffect, useState } from "react";
import AuthProvider from "../context/AuthContext";
import BetSlipContext from "../context/BetSlipContext";
import { apiGet } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import { FancyListing, SportsBookListing } from "./BetsListing";
import OpenBetsDetails from "./OpenBetsDetails";
import helper from "../Utils/helpers";
import axios from "axios";
import ParlyFIltered from "./ParlyFIltered";
import obj from "../Utils/helpers";

function Openbets() {
  let { setOpenBetsToogle, openBetsToogle, openBetSelection, setLoader, user } =
    useContext(AuthProvider);
  let {
    messaageBox,
    refreshCurrentBet,
    setRefreshCurrentBets,
    isBetPlaced,
    setIsBetPlaced,
    setMessageBox,
    umMachedBetPlace,
    setUnMatchedBetPlace,
  } = useContext(BetSlipContext);
  const [parlayData, setParlayData] = useState([]);
  const [currentBets, setCurrentBets] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [data, setData] = useState(null);
  const [type, setType] = useState("");
  const [betinfo, setBetInfo] = useState(false);
  const [sortbyTime, setSortbyTime] = useState(false);

  const getCurrentBets = async () => {
    if (!isEmpty(user)) {
      try {
        const promiseOne = await apiGet(apiPath.mobileCurrentBets);
        const promiseTwo = await apiGet(apiPath.currentParlay);
        
        const [betsResponse, parlayResponse] = await Promise.all([promiseOne, promiseTwo]);
        
        if (betsResponse.status === 200 && betsResponse.data.success) {
          setCurrentBets(betsResponse.data.results || []);
        }
        
        if (parlayResponse.status === 200 && parlayResponse.data.success) {
          setParlayData(parlayResponse.data.results || []);
        }
      } catch (error) {
        console.error('Error fetching bets:', error);
      }
    }
  };

  // console.log(currentBets, "currentBets");
  const sortTime = (check) => {
    setSortbyTime(check);
  };

  const handle = (item, type) => {
    setData(item);
    setType(type);
    
    // Set filtered bets based on type
    switch(type) {
      case "BetFair":
        setFiltered(item.betList || []);
        break;
      case "Bookmaker":
        setFiltered(item.bookmakerList || []);
        break;
      case "Fancy":
        setFiltered(item.sessionBetList || []);
        break;
      case "SportsBook":
        setFiltered(item.sportBookBetList || []);
        break;
      case "Toss":
        setFiltered((item.tossBetList || []).map(res => ({ ...res, isMatched: true })));
        break;
      case "Tie":
        setFiltered(item.tieBetList || []);
        break;
      case "Parly":
        setFiltered(item.bets || []);
        break;
      default:
        setFiltered([]);
    }
  };

  useEffect(() => {
    if (refreshCurrentBet) {
      setRefreshCurrentBets(false);
      getCurrentBets();
    }
  }, [refreshCurrentBet]);

  useEffect(() => {
    if (!isEmpty(user) && openBetsToogle) {
      getCurrentBets();
    }
  }, [user, openBetsToogle]);

  const clearBets = async (id) => {
    setLoader(true);
    try {
      const response = await apiGet(`${apiPath.clearBets}matchBetId=${id}`);
      
      if (response.status === 200) {
        if (response.data.success) {
          setRefreshCurrentBets(true);
          setIsBetPlaced("clearBet");
          setMessageBox(true);
          getCurrentBets(); // Refresh the bets after clearing
        }
      }
    } catch (error) {
      console.error('Error clearing bet:', error);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    if (umMachedBetPlace) {
      setData(null);
      setType("");
      setFiltered([]);
      setUnMatchedBetPlace(false);
    }
  }, [umMachedBetPlace]);

  return (
    <>
      {openBetsToogle && (
        <div
          id="openBetsOverlay"
          className="open-bets-overlay"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.8)",
            zIndex: 999999,
            display: "block",
          }}
        >
          <div
            id="openBetSlide"
            className="full-screen-content"
            style={{
              height: "100vh",
              display: "flex",
              flexDirection: "column",
              backgroundColor: "#f3f1f1"
            }}
          >
          <div id="sideHead" className="side-head">
            <h3 className="a-open_bets">
              <img
                src={
                  import.meta.env.VITE_IMAGE_URL +
                  "/assets/images/home/transparent.gif"
                }
                alt={""}
              />
              Open Bets
            </h3>
            <a
              id="close"
              onClick={() => setOpenBetsToogle(false)}
              className="close"
              href="#"
            ></a>
          </div>

          <div id="sideContent" className="side-content" style={{ flex: 1, overflowY: "auto" }}>
            {(!data || isEmpty(data)) && (
              <ul
                id="eventMenuList"
                style={{ display: "block", margin: 0, padding: 0 }}
                className="menu-list"
              >
                {currentBets?.length > 0 &&
                  currentBets?.map((res, index) => {
                    return (
                      <React.Fragment key={index}>
                        {res?.betList?.length > 0 && (
                          <li
                            id={`eventMenuTemplate-${index}-betfair`}
                            className="inplay-off"
                            style={{ display: "block", borderBottom: "1px solid #eee", padding: "10px" }}
                          >
                            <a
                              onClick={() => handle(res, "BetFair")}
                              href="javascript:void(0)"
                              style={{ textDecoration: "none", color: "#1f72ac", fontWeight: "bold" }}
                            >
                              {res?.eventName} - BetFair ({res?.betList?.length})
                            </a>
                          </li>
                        )}
                        {res?.bookmakerList?.length > 0 && (
                          <li
                            id={`eventMenuTemplate-${index}-bookmaker`}
                            className="inplay-off"
                            style={{ display: "block", borderBottom: "1px solid #eee", padding: "10px" }}
                          >
                            <a
                              onClick={() => handle(res, "Bookmaker")}
                              href="javascript:void(0)"
                              style={{ textDecoration: "none", color: "#333", fontWeight: "bold" }}
                            >
                              {res?.eventName} - Bookmaker ({res?.bookmakerList?.length})
                            </a>
                          </li>
                        )}
                        {res?.sessionBetList?.length > 0 && (
                          <li
                            id={`eventMenuTemplate-${index}-fancy`}
                            className="inplay-off"
                            style={{ display: "block", borderBottom: "1px solid #eee", padding: "10px" }}
                          >
                            <a
                              onClick={() => handle(res, "Fancy")}
                              href="javascript:void(0)"
                              style={{ textDecoration: "none", color: "#333", fontWeight: "bold" }}
                            >
                              {res?.eventName} - Fancy ({res?.sessionBetList?.length})
                            </a>
                          </li>
                        )}
                        {res?.sportBookBetList?.length > 0 && (
                          <li
                            id={`eventMenuTemplate-${index}-sportsbook`}
                            className="inplay-off"
                            style={{ display: "block", borderBottom: "1px solid #eee", padding: "10px" }}
                          >
                            <a
                              onClick={() => handle(res, "SportsBook")}
                              href="javascript:void(0)"
                              style={{ textDecoration: "none", color: "#333", fontWeight: "bold" }}
                            >
                              {res?.eventName} - SportsBook ({res?.sportBookBetList?.length})
                            </a>
                          </li>
                        )}
                        {res?.tieBetList?.length > 0 && (
                          <li
                            id={`eventMenuTemplate-${index}-tie`}
                            className="inplay-off"
                            style={{ display: "block", borderBottom: "1px solid #eee", padding: "10px" }}
                          >
                            <a
                              onClick={() => handle(res, "Tie")}
                              href="javascript:void(0)"
                              style={{ textDecoration: "none", color: "#333", fontWeight: "bold" }}
                            >
                              {res?.eventName} - Tie ({res?.tieBetList?.length})
                            </a>
                          </li>
                        )}
                        {res?.tossBetList?.length > 0 && (
                          <li
                            id={`eventMenuTemplate-${index}-toss`}
                            className="inplay-off"
                            style={{ display: "block", borderBottom: "1px solid #eee", padding: "10px" }}
                          >
                            <a
                              onClick={() => handle(res, "Toss")}
                              href="javascript:void(0)"
                              style={{ textDecoration: "none", color: "#333", fontWeight: "bold" }}
                            >
                              {res?.eventName} - Toss ({res?.tossBetList?.length})
                            </a>
                          </li>
                        )}
                      </React.Fragment>
                    );
                  })}
                
                {parlayData?.length > 0 &&
                  parlayData?.map((res, index) => {
                    return (
                      <li
                        id={`eventMenuTemplate-parly-${index}`}
                        key={`parly-${index}`}
                        className="inplay-off"
                        style={{ display: "block", borderBottom: "1px solid #eee", padding: "10px" }}
                      >
                        <a
                          onClick={() => handle(res, "Parly")}
                          href="javascript:void(0)"
                          style={{ textDecoration: "none", color: "#333", fontWeight: "bold" }}
                        >
                          Bet Placed -{" "}
                          {res?.bets?.length === 0
                            ? ""
                            : res?.bets?.length === 1
                            ? "SINGLE"
                            : res?.bets?.length === 2
                            ? "DOUBLE"
                            : res?.bets?.length === 3
                            ? "TREBLE"
                            : "ACCUMULATOR"}{" "}
                          - Parly
                        </a>
                      </li>
                    );
                  })}
              </ul>
            )}
            
            {data && !isEmpty(data) && (
              <>
                <div
                  id="pathWrap"
                  className="path-wrap"
                  style={{ display: "flex", padding: "0 10px", borderBottom: "1px solid #eee", alignItems: "center" }}
                >
                  <a
                    id="goBack"
                    className="go_back"
                    onClick={() => {
                      setData(null);
                      setSortbyTime(false);
                      setType("");
                      setBetInfo(false);
                    }}
                    href="javascript:void(0)"
                    style={{ marginRight: "10px", fontSize: "18px", textDecoration: "none" }}
                  >
                    &larr;
                  </a>
                  <ul style={{ margin: 0, padding: 0, listStyle: "none", flex: 1 }}>
                    <li id="eventName">
                      {type === "Parly" ? (
                        <p style={{ margin: 0 }}>
                          Bet Placed -{" "}
                          {data?.bets?.length === 0
                            ? ""
                            : data?.bets?.length === 1
                            ? "SINGLE"
                            : data?.bets?.length === 2
                            ? "DOUBLE"
                            : data?.bets?.length === 3
                            ? "TREBLE"
                            : "ACCUMULATOR"}{" "}
                          - {type}
                        </p>
                      ) : (
                        <p style={{ margin: '0', color:'#fff' }} >
                          {data?.eventName} - {type}
                        </p>
                      )}
                    </li>
                  </ul>
                </div>
                
                {type === "Parly" && data && (
                  <div
                    id="pathWrap"
                    className="path-wrap new-path"
                    style={{ display: "flex", padding: "10px", borderBottom: "1px solid #eee", flexWrap: "wrap" }}
                  >
                    <span style={{ marginRight: "15px" }}>Bet Id: {data?.matchBetId}</span>
                    <span style={{ marginRight: "15px" }}>Stake: {Number(data?.amount)?.toFixed(2)}</span>
                    <span style={{ marginRight: "15px" }}>Odds: {Number(data?.bhav)?.toFixed(2)}</span>
                    <span>
                      Win/Loss:{" "}
                      {data?.isDeclared ? (
                        <>
                          {data?.result === "loss" ? (
                            <strong style={{ color: "red" }}>{startCase(data?.result)}</strong>
                          ) : (
                            <strong style={{ color: "green" }}>{startCase(data?.result)}</strong>
                          )}
                        </>
                      ) : (
                        "..."
                      )}
                    </span>
                  </div>
                )}
              </>
            )}

            {data && !isEmpty(data) && (
              <>
                {type === "Fancy" ? (
                  <FancyListing
                    filtered={filtered}
                    sortbyTime={sortbyTime}
                    sortTime={sortTime}
                    betinfo={betinfo}
                    setBetInfo={setBetInfo}
                    type={"Matched"}
                    helper={helper}
                  />
                ) : type === "SportsBook" ? (
                  <SportsBookListing
                    filtered={filtered}
                    sortbyTime={sortbyTime}
                    sortTime={sortTime}
                    betinfo={betinfo}
                    setBetInfo={setBetInfo}
                    type={"Matched"}
                    helper={helper}
                  />
                ) : type === "Parly" ? (
                  <ParlyFIltered
                    filtered={filtered}
                    sortbyTime={sortbyTime}
                    sortTime={sortTime}
                    betType={type}
                    betinfo={betinfo}
                    setBetInfo={setBetInfo}
                    type={"Matched"}
                  />
                ) : (
                  <OpenBetsDetails
                    filtered={filtered}
                    sortbyTime={sortbyTime}
                    sortTime={sortTime}
                    betType={type}
                    betinfo={betinfo}
                    setBetInfo={setBetInfo}
                    type={"Matched"}
                  />
                )}

                {Array.isArray(filtered) && 
                 filtered.some((res) => !res?.isMatched) &&
                 type === "BetFair" && (
                  <OpenBetsDetails
                    filtered={filtered.filter(res => !res?.isMatched)} // Only show unmatched bets
                    sortbyTime={sortbyTime}
                    betinfo={betinfo}
                    betType={type}
                    setBetInfo={setBetInfo}
                    sortTime={sortTime}
                    type={"UnMatched"}
                    clearBets={clearBets}
                  />
                )}
              </>
            )}
            
            {type !== "Parly" && type !== "" && Array.isArray(filtered) && filtered.length > 0 && (
              <ul
                id="openBetOption"
                className="check-list"
                style={{ display: "flex", padding: "10px", borderTop: "1px solid #eee", backgroundColor: "#f9f9f9" }}
              >
                <li style={{ marginRight: "15px" }}>
                  <a
                    id="showBetInfo"
                    onClick={() => setBetInfo(!betinfo)}
                    className={betinfo ? "checked" : ""}
                    href="javascript:void(0)"
                    style={{ textDecoration: "none", color: betinfo ? "#007bff" : "#333" }}
                  >
                    Bet Info
                  </a>
                </li>
                {filtered?.length > 1 && type !== "SportsBook" && (
                  <li>
                    <a
                      id="showTimeOrder"
                      onClick={() => sortTime(!sortbyTime)}
                      className={sortbyTime ? "checked" : ""}
                      href="javascript:void(0)"
                      style={{ textDecoration: "none", color: sortbyTime ? "#007bff" : "#333" }}
                    >
                      Time Order
                    </a>
                  </li>
                )}
              </ul>
            )}
          </div>
        </div>
        </div>
      )}
    </>
  );
}

export default Openbets;
